export { default } from "./BaseIconButton.vue";
